import React, { useState } from 'react';

const Solutions = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div className="relative bg-white">
      {/* Content */}
      <div className="relative z-10 px-4 md:px-24 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className="mt-2 md:mt-2 md:mb-5 flex justify-between items-center p mb-2">
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#979797] md:mb-3">
            SMART FARMING |<span className='text-[#152C24]'> MARKET</span>
          </h1>
          <div>
            <div className='flex md:gap-2 gap-1 justify-center md:mt-2'>
              <div className='bg-[#CFD7D7] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
              <div className="bg-[#2E453D] border-b-[3px] border-[#FFBD26] md:ml-0 ml-2 text-white font-normal md:px-6 px-2 rounded-md md:rounded-[30px] w-[70px] h-[15px] md:w-[150px] md:text-[20px] text-[6px] md:h-[40px] mt-0 md:-mt-[1px] flex justify-between items-center">
                See More
              </div>
              <div className='bg-[#2E453D] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 mr-2 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
            </div>
          </div>
        </div>

        {/* Records Section */}
        <div className="rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center p-2 md:p-0 pt-2 mt-4">
          <div className="rounded-xl overflow-hidden relative w-full h-[300px] md:mt-5 md:h-[700px] flex justify-center items-center cursor-pointer">
            <>
              <img
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751398192/image-3_x1vso0.png"
                alt="Mobile"
                className="object-cover w-full h-full"
              />
            </>
          </div>
        </div>

        {/* Description */}
        <div className='md:text-[32px] text-[10px] font-normal md:mt-16 mt-2 space-y-6'>
          <h1 className="text-[12px] md:text-[36px] font-bold md:mb-3">
            <span className='text-[#152C24]'>MARKET - CONTRACT FARMING</span>
          </h1>

          <div className="space-y-2 sm:space-y-1">
            <p className="md:text-[32px] text-[8px]">
              The user profile functionality of the Farmers Network app allows each farmer to create and manage a personalized account that captures key details such as location, farm size, crop and livestock types, service needs, and farming goals.
            </p>
          </div>
          <p className="md:text-[32px] text-[8px] md:mt-8 mt-3">
            This information enables the app to deliver tailored content, recommendations, and alerts—such as localized weather forecasts, market prices, and relevant service provider connections—ensuring each user receives a customized and relevant farming experience.
          </p>
        </div>
    
        <div className='md:h-10 h-5'></div>
      </div>
    </div>
  );
};

export default Solutions;